import { Injectable, inject } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppConfig } from '../config';

@Injectable({ providedIn: 'root' })
export class CryptoService {
  private config = inject(AppConfig);

  doubleEncrypt(value: unknown): string {
    const str = typeof value === 'string' ? value : JSON.stringify(value);
    const once = CryptoJS.AES.encrypt(str, this.config.settings.publicKey).toString();
    return CryptoJS.AES.encrypt(once, this.config.settings.saltKey).toString();
  }

  doubleDecrypt(encrypted: string): unknown {
    try {
      const once = CryptoJS.AES.decrypt(encrypted, this.config.settings.saltKey).toString(
        CryptoJS.enc.Utf8
      );
      const twice = CryptoJS.AES.decrypt(once, this.config.settings.publicKey).toString(
        CryptoJS.enc.Utf8
      );
      try {
        return JSON.parse(twice);
      } catch {
        return twice;
      }
    } catch (e) {
      console.error('Decryption failed', e);
      throw new Error('Failed to decrypt value');
    }
  }
}
